import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  createTicketApi,
  forwardTicketApi,
  updateTicketApi,
  updateTicketStatusApi,
  addTicketCommentApi,
  getTicketDetailsApi,
  getTicketCommentsApi,
  getTicketListApi,
  getTicketCategoryWiseCount,
  getTicketAssignToUserCount,
} from "@/apis/supportApis";

import type {
  CreateTicketPayloadType,
  ForwardTicketPayloadType,
  UpdateTicketPayloadType,
  UpdateTicketStatusPayloadType,
  AddTicketCommentPayloadType,
  GetTicketDetailsPayloadType,
  GetTicketCommentsPayloadType,
  GetTicketListPayloadType,
  GetTicketCategoryWiseCount,
  GetTicketAssigedToUserCount,
} from "@/commonTypes/supportTypes";

/* ------------------- ACTIONS ------------------- */

export const createTicketAction = createAsyncThunk(
  "tickets/create",
  async (data: CreateTicketPayloadType) => {
    const response = await createTicketApi(data);
    return response.data;
  }
);

export const forwardTicketAction = createAsyncThunk(
  "tickets/forward",
  async (data: ForwardTicketPayloadType) => {
    const response = await forwardTicketApi(data);
    return response.data;
  }
);

export const updateTicketAction = createAsyncThunk(
  "tickets/update",
  async (data: UpdateTicketPayloadType) => {
    const response = await updateTicketApi(data);
    return response.data;
  }
);

export const updateTicketStatusAction = createAsyncThunk(
  "tickets/updateStatus",
  async (data: UpdateTicketStatusPayloadType) => {
    const response = await updateTicketStatusApi(data);
    return response.data;
  }
);

export const addTicketCommentAction = createAsyncThunk(
  "tickets/addComment",
  async (data: AddTicketCommentPayloadType) => {
    const response = await addTicketCommentApi(data);
    return response.data;
  }
);

export const getTicketDetailsAction = createAsyncThunk(
  "tickets/getDetails",
  async (data: GetTicketDetailsPayloadType) => {
    const response = await getTicketDetailsApi(data);
    return response.data;
  }
);

export const getTicketCommentsAction = createAsyncThunk(
  "tickets/getComments",
  async (data: GetTicketCommentsPayloadType) => {
    const response = await getTicketCommentsApi(data);
    return response.data;
  }
);

export const getTicketListAction = createAsyncThunk(
  "tickets/getTicketListAction",
  async (data: GetTicketListPayloadType) => {
    const response = await getTicketListApi(data);
    return response.data;
  }
);

export const getAllTicketListAction = createAsyncThunk(
  "tickets/getAllTicketListAction",
  async (data: GetTicketListPayloadType) => {
    const response = await getTicketListApi(data);
    return response.data;
  }
);

export const getTicketCategoryWiseCountAction = createAsyncThunk(
  "tickets/getTicketCategoryWiseCountAction",
  async (data: GetTicketCategoryWiseCount) => {
    const response = await getTicketCategoryWiseCount(data);
    return response.data;
  }
);
export const getTicketAssignedToUserAction = createAsyncThunk(
  "tickets/getTicketAssignedToUserAction",
  async (data: GetTicketAssigedToUserCount) => {
    const response = await getTicketAssignToUserCount(data);
    return response.data;
  }
);
